import React from "react";
import { FlaskConical } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

interface TrialBadgeProps {
  /** Hover copy; omit for a plain badge. */
  tooltip?: string;
  label?: string;
  className?: string;
}

/** Small "Trial" pill used next to labels and in the "Sending to" box. */
const TrialBadge: React.FC<TrialBadgeProps> = ({ tooltip, label = "Trial", className }) => {
  const pill = (
    <span
      data-testid="trial-badge"
      className={cn(
        "inline-flex items-center gap-1 rounded-full border border-amber-300 bg-amber-50 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-amber-800 dark:border-amber-700 dark:bg-amber-950/40 dark:text-amber-200",
        tooltip && "cursor-help",
        className
      )}
    >
      <FlaskConical className="h-3 w-3" aria-hidden />
      {label}
    </span>
  );

  if (!tooltip) return pill;

  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span tabIndex={0} className="inline-flex outline-none">
            {pill}
          </span>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-xs text-xs leading-relaxed">
          {tooltip}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default TrialBadge;
